import { Component, OnInit } from '@angular/core';

import DataSource from 'devextreme/data/data_source';
import CustomStore from 'devextreme/data/custom_store';

import { HttpCodeService } from 'src/app/services/http/http-code.service';
import { BaseSubscriptionComponent } from 'src/app/base/base.suscription.component';
import { lastValueFrom, takeUntil } from 'rxjs';
import { setUpdateValues } from 'src/app/helper/common-helper';

@Component({
  selector: 'app-priorities',
  templateUrl: './priorities.component.html',
})
export class PrioritiesComponent extends BaseSubscriptionComponent implements OnInit {
  public priorities: DataSource;

  constructor(private httpCodesService: HttpCodeService) {
    super();
  }

  public ngOnInit(): void {
    this.priorities = this.prioritiesDatasource();
  }

  public setEditedValue(e, cellInfo): void {
    cellInfo.setValue(e.value);
  }

  private prioritiesDatasource(): DataSource {
    return new DataSource({
      store: new CustomStore({
        key: 'Id',
        load: () => lastValueFrom(this.httpCodesService.getPriorities().pipe(takeUntil(this.destroyed))),
        update: (id, values) => {
          const toUpdate = this.priorities.items().find((_) => _.Id == id);

          setUpdateValues(values, toUpdate);

          return lastValueFrom(this.httpCodesService.updatePriority(toUpdate).pipe(takeUntil(this.destroyed)));
        },
        remove: (id) => lastValueFrom(this.httpCodesService.deletePriority(id).pipe(takeUntil(this.destroyed))),
        insert: (priority) =>
          lastValueFrom(this.httpCodesService.insertPriority(priority).pipe(takeUntil(this.destroyed))),
      }),
    });
  }
}
